export const RNS_SHOW_NOTIFICATION = 'RNS_SHOW_NOTIFICATION';
export const RNS_HIDE_NOTIFICATION = 'RNS_HIDE_NOTIFICATION';
export const RNS_REMOVE_ALL_NOTIFICATIONS = 'RNS_REMOVE_ALL_NOTIFICATIONS';
